import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import BoxGif from '../../images/bolsa-gif.gif'
import { Link } from 'gatsby';

function Portada() {

  const [showFollowOrder, setShowFollowOrder] = useState(false);

  const handleShowFollowOrder = () => {
    setShowFollowOrder(!showFollowOrder);
    // Aquí puedes realizar cualquier otra acción con el elemento seleccionado
  };
  useEffect(() => {
    // Inicializa AOS solo cuando el componente se monta en el cliente
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <div className="Content__portada">
        <div className="container">
            <div className="Content__portada--container">
                <div className="Content__portada--heading"  data-aos="fade-up">
                    <h1><strong>Recíbelo</strong> es la solución <br /> <strong>logística de <span>última milla</span> <br /> para tu negocio</strong></h1>
                    <h2>Entregas en el mismo dia</h2>
                    <h2>Nextday</h2>
                    <h2>Sameday</h2>
                    <h2>Reparto</h2>
                </div>
                <button className="Content__followOrder--button" onClick={handleShowFollowOrder} data-aos="fade-down">
                  <span style={{display: 'flex', gap: '10px'}}>¿Dónde viene mi pedido?  <i className="fa-solid fa-magnifying-glass"></i></span>
                    <Link to="/seguimiento" className={`Content__followOrder--order ${showFollowOrder == true ? "activeFollowOrder" : ""}`}>
                        <div className="Content__followOrder--order-title">
                            <h2>¿Dónde viene <span>mi pedido?</span></h2>
                            <div className="Content__followOrder--order-text">
                                <p>¡Descúbrelo ahora!</p>
                            </div>
                        </div>
                        <div className="Content__followOrder--order-icon">
                            <img src={BoxGif} alt="caja-gif" width="80" height="80" />
                        </div>
                    </Link>
                </button>
            </div>
        </div>
        <div className="portOverlay"></div>
    </div>
  )
}

export { Portada }